import { render } from "./TonePicker.vue?vue&type=template&id=2748a0ba&scoped=true&ts=true"
import script from "./TonePicker.vue?vue&type=script&lang=ts"
export * from "./TonePicker.vue?vue&type=script&lang=ts"

import "./TonePicker.vue?vue&type=style&index=0&id=2748a0ba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2748a0ba"]])

export default __exports__